export default __webpack_public_path__ + "static/media/V545_E_BD.e2ed4694.pdf";